










import EventType from '@/model/enums/EventType';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EventIcon extends Vue {
    @Prop({ type: String, default: EventType.NONE })
    readonly eventType!: EventType;

    @Prop({ type: String, default: 'light' }) readonly mode!: string;

    @Prop({ type: Number, default: 48 }) readonly size!: number;

    get imageName(): string {
        return (this.eventType ?? EventType.NONE)
            .toString()
            .toLowerCase()
            .replace('_', '-');
    }
}
